/* Motion and interaction layer from the Aurm design handoff (aurm-motion.js).
   Self-installing: reveals, count-ups, growing bars, card spotlight, magnetic CTAs,
   press feedback and the hero parallax. Imported once for its side effects. */
(function () {
  if (window.__aurmMotion) return; window.__aurmMotion = true;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  var EASE = 'cubic-bezier(.22,.8,.24,1)';
  var css = document.createElement('style');
  css.textContent = '[data-m]:not([data-m-in]){opacity:0}' +
    '[data-spot]{position:absolute;inset:0;border-radius:inherit;pointer-events:none;opacity:0;transition:opacity .5s ease-out;background:radial-gradient(420px circle at var(--sx,50%) var(--sy,50%),rgba(255,255,255,.07),rgba(255,255,255,0) 60%);z-index:0}' +
    '[data-spot-host]:hover>[data-spot]{opacity:1}' +
    '[data-mag]{transition:translate .5s cubic-bezier(.22,.8,.24,1),filter .3s ease-out}' +
    '[data-spot-host] img{transition:transform 1.4s cubic-bezier(.22,.8,.24,1)}[data-spot-host]:hover img{transform:scale(1.035)}' +
    (reduce ? '' : 'html [data-reveal]{transform:translateY(24px);filter:blur(6px);transition:opacity .95s cubic-bezier(.22,.8,.24,1),transform .95s cubic-bezier(.22,.8,.24,1),filter .95s cubic-bezier(.22,.8,.24,1)}html [data-reveal].in{transform:none;filter:none}');
  document.head.appendChild(css);

  var isPages = true;
  var REVEAL = ['h1','h2','h3','section > p','section dl','figure','article','ol > li','blockquote','[role=tablist]','section > div > a','section > a','section ul > li'].map(function (x) { return '[data-pages-root] ' + x + ',main[style] ' + x; }).join(',');
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); show(e.target); } });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 }) : null;
  var queue = [], qt = 0;
  function show(el) {
    queue.push(el);
    if (qt) return;
    qt = requestAnimationFrame(function () {
      queue.forEach(function (n, i) {
        n.setAttribute('data-m-in', '');
        n.animate([{ opacity: 0, transform: 'translateY(18px)', filter: 'blur(4px)' }, { opacity: 1, transform: 'none', filter: 'blur(0)' }],
          { duration: 820, delay: Math.min(i, 6) * 70, easing: EASE, fill: 'backwards' });
        countUp(n);
      });
      queue = []; qt = 0;
    });
  }
  function countUp(root) {
    root.querySelectorAll && root.querySelectorAll('dd').forEach(function (dd) {
      var tn = Array.prototype.find.call(dd.childNodes, function (c) { return c.nodeType === 3 && /\d/.test(c.nodeValue); });
      if (!tn || tn.__counted) return; tn.__counted = true;
      var m = tn.nodeValue.match(/^(\D*)([\d,]+)(.*)$/); if (!m) return;
      var end = parseInt(m[2].replace(/,/g, ''), 10), comma = m[2].indexOf(',') > -1, t0 = performance.now(), dur = 1400, fin = tn.nodeValue;
      (function step(t) {
        var k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 4), v = Math.round(end * e);
        tn.nodeValue = k >= 1 ? fin : m[1] + (comma ? v.toLocaleString('en-IN') : v) + m[3];
        if (k < 1) requestAnimationFrame(step);
      })(t0);
    });
  }
  function isCard(el) {
    var cs = getComputedStyle(el);
    return parseFloat(cs.borderTopLeftRadius) >= 18 && parseFloat(cs.borderTopWidth) === 1 && /rgba?\(255, 255, 255/.test(cs.borderTopColor) && el.offsetWidth > 220 && el.offsetHeight > 120;
  }
  function isCta(el) {
    var cs = getComputedStyle(el), h = el.offsetHeight;
    return parseFloat(cs.borderTopLeftRadius) >= 22 && h >= 44 && h <= 70 && el.offsetWidth > 100 && el.offsetWidth < 420;
  }
  function scan(root) {
    if (!root.querySelectorAll) return;
    if (isPages && io && !reduce) root.querySelectorAll(REVEAL).forEach(function (el) {
      if (el.__m || el.closest('header,footer,[data-m]')) return; el.__m = true;
      el.setAttribute('data-m', ''); io.observe(el);
    });
    if (!fine || reduce) return;
    root.querySelectorAll('div[style],a[style],article[style],figure[style],aside[style]').forEach(function (el) {
      if (el.__spot || !isCard(el)) return; el.__spot = true;
      if (getComputedStyle(el).position === 'static') el.style.position = 'relative';
      var s = document.createElement('i'); s.setAttribute('data-spot', ''); s.setAttribute('aria-hidden', 'true');
      el.appendChild(s); el.setAttribute('data-spot-host', '');
      el.addEventListener('pointermove', function (e) { var r = el.getBoundingClientRect(); el.style.setProperty('--sx', (e.clientX - r.left) + 'px'); el.style.setProperty('--sy', (e.clientY - r.top) + 'px'); }, { passive: true });
    });
    root.querySelectorAll('a[style],button[style]').forEach(function (el) {
      if (el.__mag || !isCta(el)) return; el.__mag = true; el.setAttribute('data-mag', '');
      el.addEventListener('pointermove', function (e) { var r = el.getBoundingClientRect(); var x = (e.clientX - r.left - r.width / 2) / r.width, y = (e.clientY - r.top - r.height / 2) / r.height; el.style.translate = (x * 6).toFixed(1) + 'px ' + (y * 5).toFixed(1) + 'px'; }, { passive: true });
      el.addEventListener('pointerleave', function () { el.style.translate = '0px 0px'; });
    });
  }
  if (!reduce) document.addEventListener('pointerdown', function (e) {
    var b = e.target.closest && e.target.closest('a,button'); if (!b) return;
    b.animate([{ scale: 1 }, { scale: .97 }, { scale: 1 }], { duration: 320, easing: EASE });
  }, { passive: true });
  function stagger(root) {
    if (reduce || !root.querySelectorAll) return;
    root.querySelectorAll('[data-reveal]').forEach(function (el) {
      if (el.__st) return; el.__st = true;
      var sib = el.parentNode ? Array.prototype.filter.call(el.parentNode.children, function (c) { return c.hasAttribute('data-reveal'); }) : [el];
      var i = sib.indexOf(el); if (i > 0) el.style.transitionDelay = Math.min(i, 5) * 90 + 'ms';
    });
  }
  function parallax() {
    if (reduce) return;
    var wrap = document.querySelector('[data-hero-stage-wrap]'); if (!wrap) return;
    var raf = 0;
    window.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; var r = wrap.getBoundingClientRect(); if (r.bottom < -100 || r.top > window.innerHeight + 100) return; var c = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight; wrap.style.translate = '0 ' + (c * 36).toFixed(1) + 'px'; }); }, { passive: true });
  }
  var cio = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) { es.forEach(function (e) { if (!e.isIntersecting) return; cio.unobserve(e.target); runCount(e.target); }); }, { threshold: 0.6 }) : null;
  function runCount(el) {
    var tn = Array.prototype.find.call(el.childNodes, function (c) { return c.nodeType === 3 && /\d/.test(c.nodeValue); });
    if (!tn) return; var fin = tn.nodeValue, mm = fin.match(/^(\D*)([\d,]+)(.*)$/); if (!mm) return;
    var end = parseInt(mm[2].replace(/,/g, ''), 10), comma = mm[2].indexOf(',') > -1, t0 = performance.now(), dur = 1600;
    (function step(t) { var k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 4), v = Math.round(end * e);
      tn.nodeValue = k >= 1 ? fin : mm[1] + (comma ? v.toLocaleString('en-IN') : v) + mm[3]; if (k < 1) requestAnimationFrame(step); })(t0);
  }
  var gio = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) { es.forEach(function (e) { if (!e.isIntersecting) return; gio.unobserve(e.target); e.target.animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], { duration: 1400, easing: EASE, fill: 'backwards' }); }); }, { threshold: 0.6 }) : null;
  function counts(root) { if (!reduce && gio && root.querySelectorAll) root.querySelectorAll('[data-grow]').forEach(function (el) { if (el.__g) return; el.__g = true; gio.observe(el); }); if (reduce || !cio || !root.querySelectorAll) return; root.querySelectorAll('[data-count]').forEach(function (el) { if (el.__c) return; el.__c = true; cio.observe(el); }); }
  function boot() {
    counts(document.body); setTimeout(function () { counts(document.body); }, 1000);
    stagger(document.body); setTimeout(function () { stagger(document.body); parallax(); }, 800);
    scan(document.body);
    new MutationObserver(function (ms) { ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1 && !n.hasAttribute('data-spot')) { scan(n.parentNode || n); stagger(n.parentNode || n); counts(n.parentNode || n); } }); }); })
      .observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { scan(document.body); }, 1200);
    setTimeout(function () { document.querySelectorAll('[data-m]:not([data-m-in])').forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < window.innerHeight && r.bottom > 0) show(el); }); }, 2500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
